import "./intro.css";
import Me from "../../img/data.gif";

const Intro = () => {
  return (
    <section id="home">
      <div className="i">
        <div className="i-left">
          <div className="i-left-wrapper">
            <h2 className="i-intro" data-aos="fade-right">
              Hello, My name is
            </h2>
            <h1 className="i-name" data-aos="fade-right">
              Atharva Pandhare
            </h1>
            <div className="i-title" data-aos="fade-right">
              <div className="i-title-wrapper">
                <div className="i-title-item">Web Developer</div>
                <div className="i-title-item">UI/UX Designer</div>
                <div className="i-title-item">React Developer</div>
                <div className="i-title-item">Problem Solver</div>
                <div className="i-title-item">Video Editor</div>
              </div>
            </div>
            <p className="i-desc" data-aos="fade-up">
              I am a curious learner who likes to experiment with new
              technologies to integrate with my current skill set. Proficient in
              my work and have a creative touch to it. I am a hard worker and a
              developer who enjoys taking on responsibilities. My main aim is to
              gain enough expertise in emerging technologies to build a great
              product/ services which would help people.
            </p>
            <div className="flex" data-aos="fade-up">
              <a href="https://drive.google.com/file/d/1vDxqjEWRQmjFXaxQ8ZVIlDFm3aFlLUVn/view" target="_blank">
                <button className="primary-btn">Resume</button>
              </a>
              <a href="https://www.linkedin.com/in/atharva-pandhare/">
                <button className="secondary-btn">Connect now!</button>
              </a>
            </div>
          </div>
          <svg
            width="75"
            height="75"
            viewBox="0 0 75 75"
            fill="none"
            stroke="black"
            className="i-scroll"
            data-aos="fade-up"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="scroll">
              <path
                id="Vector"
                d="M40.5 15L34.5 9L28.5 15"
                stroke-width="3"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_2"
                d="M28.5 24L34.5 30L40.5 24"
                stroke-width="3"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <g id="Group">
                <path
                  id="Vector_3"
                  d="M9 37.5H60"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <path
                id="Vector_4"
                d="M34.5 27V9"
                stroke-width="2.9895"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <g id="Group_2">
                <path
                  id="Vector_5"
                  d="M9 27C9 12.918 20.418 1.5 34.5 1.5C48.5859 1.5 60 12.918 60 27C60 29.8906 60 45.1094 60 48C60 62.082 48.5859 73.5 34.5 73.5C20.418 73.5 9 62.082 9 48C9 45.1094 9 29.8906 9 27Z"
                  stroke-width="3"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        </div>
        <div className="i-right">
          <img src={Me} alt="" className="i-img" data-aos="fade-left" />
        </div>
      </div>
    </section>
  );
};

export default Intro;
